<!-- 新的文档中心 -->
<template>
	<div class="content_wrap">
		<div class="warp_box clearfix">
			<div class="left_box">
				<div class="title">API Keys管理中心</div>
			</div>
			<div class="handleAdd">
				<a-button type="primary" @click="createApi">
					新增API Key
				</a-button>
			</div>
			<a-table :locale="{ emptyText: '暂无数据' }" bordered :data-source="dataSource" :columns="columns">
				<span slot="status" slot-scope="status,record">
					<a-switch @change="() => onChange(record)" :default-checked="!!status" />
				</span>
				<span slot="operation" slot-scope="text,record">
					<a href="javascript:;" @click="() => onChangeName(record)"> 修改 </a>
					<a-popconfirm title="确定删除本APIKey吗？" ok-text="确定" cancel-text="取消" @confirm="() => onDel(record)">
						<a href="#">删除</a>
					</a-popconfirm>
				</span>
			</a-table>
		</div>
		<a-modal v-if="visible" v-model="visible" :title="title" @ok="handleOk" ok-text="确认" cancel-text="取消">
			<a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
				<a-form-item label="API Key名称">
					<a-input placeholder="请输入API Key名称"
						v-decorator="['name', { rules: [{ required: true, message: '请输入API Key名称！' }] }]" />
				</a-form-item>
			</a-form>
		</a-modal>
	</div>
</template>
<script>
import moment from 'moment'
export default {
	name: 'documentCenter',
	data() {
		return {
			dataSource: [],
			currentData: {},
			columns: [
				{
					title: '名称',
					dataIndex: 'name',
				},
				{
					title: 'Key',
					dataIndex: 'apiKey',
				},
				{
					title: '是否启用',
					dataIndex: 'status',
					scopedSlots: { customRender: 'status' },
				},
				{
					title: '创建时间',
					dataIndex: 'createTime',
					customRender: (text) => {
						return moment(text).format('YYYY-MM-DD')
					}
				},
				{
					title: '更新时间',
					dataIndex: 'updateTime',
					customRender: (text) => {
						return moment(text).format('YYYY-MM-DD')
					}
				},
				{
					title: '操作',
					dataIndex: 'operation',
					scopedSlots: { customRender: 'operation' },
				},
			],
			visible: false,
			title: '新增',
			form: this.$form.createForm(this, { name: 'apiKey' }),
		}
	},
	mounted() {
		this.getTableList()
	},
	methods: {
		getTableList(params = {}) {
			this.http.post('/ystOpenPlatformBff/apiKey/queryApiList', {}, res => {
				if (res.success) {
					this.dataSource = res.data
				} else {
					this.$message.warning(res.message)
				}
			})
		},
		onDel(value) {
			this.http.post('/ystOpenPlatformBff/apiKey/delApiByKey', { apiKey: value.apiKey }, res => {
				if (res.success) {
					this.getTableList()
					this.$message.success('删除成功！')
				} else {
					this.$message.warning(res.message)
				}
			})
		},
		onChangeName(value) {
			this.visible = true
			this.title = '修改名称'
			this.currentData = value
		},
		createApi() {
			this.visible = true
			this.title = '新增'
		},
		onChange(value) {
			let status = !value.status
			this.http.post('/ystOpenPlatformBff/apiKey/updateStatus', { apiKey: value.apiKey, status: +status }, res => {
				if (res.success) {
					this.getTableList()
					this.$message.success('修改成功！')
				} else {
					this.$message.warning(res.message)
				}
			})
		},
		// 页面修改
		pageOnChange(page) {
			let params = {
				pageNumber: page.current,
				pageSize: page.pageSize
			}
			this.getTableList(params)
		},
		// 提交申请
		handleOk(e) {
			let api = '', message = ''
			e.preventDefault();
			this.form.validateFields((err, values) => {
				if (this.title === '新增') {
					api = '/ystOpenPlatformBff/apiKey/createKey'
					message = "创建成功！"
				} else {
					api = '/ystOpenPlatformBff/apiKey/changeApiName'
					message = "修改成功！"
					values.apiKey = this.currentData.apiKey
				}
				if (!err) {
					this.http.post(api, values, res => {
						if (res.success) {
							this.$message.success(message)
							this.visible = false
							this.getTableList()
						} else {
							this.$message.warning(res.message)
						}
					})
				}
			});
		},
	}
}
</script>

<style lang="scss" scoped>
button {
	padding: 0px 10px
}

input {
	border: 1px solid #ccc;
	padding-left: 10px;
}

.content_wrap {
	background: $backg;
	padding: 30px 0;

	td {
		button {
			border-radius: 10px;
		}
	}

	.warp_box {
		position: relative;
		width: 1200px;
		margin: 0 auto;
		background: $white;
		padding: 20px;

		.handleAdd {
			text-align: right;
			margin-bottom: 10px;
		}
	}

	.left_box {
		width: 220px;
		font-size: 14px;
		margin-bottom: 12px;
		color: $gredF;
		line-height: 40px;

		/*border-right: 1px solid $border;*/
		.title {
			color: $title;
			padding-left: 20px;
			border-bottom: 1px solid $border;
		}

		.list {
			padding-top: 10px;
			min-height: 827px;
		}

		.active {
			background: $white;
			color: $hover;
			border-right: 3px solid $hover;
		}

		.title_active {
			background: $white;
			color: $hover;
			border-right: 1px solid $border;
		}
	}

}
</style>



// WEBPACK FOOTER //
// src/page/ApiCenter.vue